
export const getApiUrl = (path) => {
  let apiPath = path

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    if (isLocal && process.env.REACT_APP_LOCAL_API_HOST) {
      return `${process.env.REACT_APP_LOCAL_API_HOST.replace(/\/$/, '')}${apiPath}`;
    }
  }
   apiPath = `/payroll-api${path}`;
  return apiPath;
};

/**
 * A centralized fetch utility for making API calls.
 * It automatically adds the 'Content-Type' and 'X-Tenant-ID' headers.
 *
 * @param {string} endpoint - The API endpoint to call (e.g., '/organizations').
 * @param {string} tenantId - The tenant ID for the 'X-Tenant-ID' header.
 * @param {object} options - Optional fetch options (method, body, etc.).
 * @returns {Promise<any>} - The JSON response from the API.
 */
export const apiFetch = async (endpoint, tenantId, options = {}) => {
  const { method = 'GET', body = null, parseResponse = true, ...customOptions } = options;

  const headers = {
    'Content-Type': 'application/json',
    ...customOptions.headers,
  };

  if (tenantId) {
    headers['X-Tenant-ID'] = tenantId;
  }

  const config = {
    method,
    headers,
    ...customOptions,
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  const url = getApiUrl(endpoint);

  const response = await fetch(url, config);

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: response.statusText }));
    throw new Error(error.message || 'An unknown error occurred');
  }

  // For file downloads, return the raw response object
  if (!parseResponse) {
    return response;
  }

  // For DELETE or other methods that might not return a body
  if (response.status === 204) {
    return null;
  }

  return response.json();
};